// @core/api/endpoints/fiscalization/get_fiscal_provider.ts
// Auto-generated by corebuilder. DO NOT EDIT.

import { getApiClient, type RequestOptions } from '../../client';
import type {
  GetFiscalProviderResponse,
} from '../../../types/fiscalization';

const BASE_PATH = '/fiscalization';

/**
 * Get fiscal provider by ID
 * Retrieves a fiscal provider configuration by its unique identifier.
 */
export async function GetFiscalProvider(
  id: string,
  options?: RequestOptions
): Promise<GetFiscalProviderResponse> {
  const client = getApiClient();
  let requestPath = `${BASE_PATH}/fiscal-providers/:id`;
  requestPath = requestPath.replace(':id', encodeURIComponent(id));
  const requestOptions = options;
  return client.get<GetFiscalProviderResponse>(requestPath, { ...requestOptions });
}
